import React, { PureComponent } from 'react';

import Button from 'widgets/Button';

export default class FoodProfileStep3 extends PureComponent {
  render() {
    return (
      <div className="js-foodProfilePopup__step3">
        <div className="js-foodProfilePopup__headerBar">
          <h3>How do you know what to look for?</h3>
          <Button
            className="js-createFoodProfileClose"
            onClick={this.props.closeHandler}
          />
        </div>
        <p>
          You’ll see the following warning flag if a product label contains any
          ingredients you’ve selected as not being able to eat. In this example,
          gluten (all cereals) has been selected and flagged in a search for pasta:
        </p>
        <div className="js-foodProfilePopup__labelling">
          <img
            className="js-foodProfilePopup__badge"
            src="/webshop/static/images/components/foodProfile/flagged_badge.png"
            alt=""
          />
        <p>
            We’ll also flag any items where the packaging includes a potential
            cross-contamination statement similar to: ‘not suitable for’,
            ‘may contain’, or ‘made in a factory’.
        </p>
          <img
            className="js-foodProfilePopup__productLabelling"
            src="/webshop/static/images/components/foodProfile/flagged_product.png"
            alt=""
          />
        <p className="js-foodProfilePopup__smallText">
            Please remember: while this has been designed to save you time by identifying
            foods that aren’t suitable for you, it’s always best to check the ingredients
            before adding them to your shop or consuming.
        </p>
        <p className="js-foodProfilePopup__smallText">
            By saving your profile, you accept our <a href="/webshop/scontent/FoodProfileTerms">
              terms and conditions</a>.
        </p>
        </div>
        <div className="js-foodProfilePopup__actionBar">
          <a href="https://www.foodmaestro.me/">Powered by Foodmaestro</a>
          <Button
            onClick={this.props.nextStepHandler}
          >
            Save my profile
          </Button>
        </div>
        <div className="gn-multiStepIndicator js-foodProfilePopup__stepIndicator">
          <span className="filled" />
          <span className="filled" />
          <span className="filled" />
        </div>
      </div>
    );
  }
}
